
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor/[id]/compare",
      function () {
        return require("private-next-pages/vendor/[id]/compare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor/[id]/compare"])
      });
    }
  